import React, { Fragment } from 'react'

import { Helmet } from 'react-helmet'

import HeaderMain from '../components/header-main'
import Componenttextimage from '../components/componenttextimage'
import Component4cards from '../components/component4cards'
import FooterMain from '../components/footer-main'
import './founder.css'

const LeonidZhabrev = (props) => {
  return (
    <div className="founder-container">
      <Helmet>
        <title>Жабрев Леонид — CEO и основатель Arcobo</title>
        <meta
          name="description"
          content="Жабрев Леонид — CEO и основатель Arcobo: промышленная автоматизация, роботизированная сварка и WAAM 3D-печать металлом в Казахстане и Центральной Азии."
        />
        <meta
          property="og:title"
          content="Жабрев Леонид — CEO и основатель Arcobo"
        />
        <meta
          property="og:description"
          content="Жабрев Леонид — CEO и основатель Arcobo: промышленная автоматизация, роботизированная сварка и WAAM 3D-печать металлом."
        />
        <meta
          property="og:image"
          content="https://arcobo.tech/og_image.png"
        />
        <meta property="og:type" content="profile" />
        <meta
          name="twitter:title"
          content="Жабрев Леонид — CEO и основатель Arcobo"
        />
        <meta
          name="twitter:description"
          content="Жабрев Леонид — CEO и основатель Arcobo: промышленная автоматизация, роботизированная сварка и WAAM 3D-печать металлом."
        />
        <meta
          name="twitter:image"
          content="https://arcobo.tech/og_image.png"
        />
        <link
          rel="canonical"
          href="https://arcobo.tech/leonid-zhabrev"
        />
        <meta
          property="og:url"
          content="https://arcobo.tech/leonid-zhabrev"
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html:
              '{"@context":"https://schema.org","@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"Home","item":"https://arcobo.tech"},{"@type":"ListItem","position":2,"name":"Leonid Zhabrev","item":"https://arcobo.tech/leonid-zhabrev"}]}',
          }}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html:
              '{"@context":"https://schema.org","@type":"Person","name":"Жабрев Леонид","givenName":"Леонид","familyName":"Жабрев","jobTitle":"CEO","worksFor":{"@type":"Organization","name":"Arcobo","url":"https://arcobo.tech"},"url":"https://arcobo.tech/leonid-zhabrev","sameAs":"https://www.linkedin.com/in/leozhabrev"}',
          }}
        />
      </Helmet>
      <HeaderMain></HeaderMain>
      <Componenttextimage
        image1Src="/Founders/leonid-zhabrev.webp"
        image1Alt="Жабрев Леонид — CEO Arcobo"
        textComponent={
          <Fragment>
            <span className="founder-role">CEO</span>
            <br></br>
            <br></br>
            <span className="founder-text">
              <span>
                Инженер в области промышленной автоматизации,
                роботизированной сварки и аддитивного производства. С 2017
                года участвует в прикладных R&D и внедрении инженерных
                решений.
              </span>
              <br></br>
              <br></br>
              <span>
                Основатель и генеральный директор Arcobo, с 2025 года —
                директор Arcobo Robotics, официального представителя
                Kawasaki Robotics в Казахстане.
              </span>
            </span>
          </Fragment>
        }
        componentTitle="Жабрев Леонид"
      ></Componenttextimage>
      <div className="founder-sections">
        <div className="founder-section">
          <h2 className="H1_medium">Профессиональный профиль</h2>
          <p className="text_medium">
            Специализация — анализ производственных задач, формирование
            технических требований, выбор технологии и оборудования,
            организация разработки ПО и внедрения автоматизированных
            комплексов.
          </p>
          <ul className="founder-list text_medium">
            <li>
              Автоматизация технологических процессов: обследование
              производства, технические задания, подбор конфигурации
              роботизированных комплексов, оценка производительности и
              экономического эффекта
            </li>
            <li>
              Программные решения для производства: постановка задач на
              разработку, автоматизация подготовки моделей и управляющих
              программ, интеграция ПО с оборудованием, цифровая
              прослеживаемость
            </li>
            <li>
              Роботизированная сварка и наплавка, WAAM-печать металлом;
              координация инженеров, разработчиков и технологов
            </li>
          </ul>
        </div>
      </div>
      <Component4cards
        title1="ПЗТА — наплавка арматуры"
        title2="КазЭнергоПауер — шины"
        title3="КазЭнергоПауер — Salvagnini"
        title4="ТОО «Тяга» — сопла"
        heading1="Ключевые проекты"
        imageSrc="/Founders/icons/robot-200w.webp"
        imageAlt="Роботизированная наплавка"
        imageSrc1="/icons/programming-200w.webp"
        imageAlt1="ORTHODROM — автоматизация подготовки"
        imageSrc2="/icons/gear-200w.webp"
        imageAlt2="Адаптация развёрток Salvagnini"
        imageSrc3="/Founders/icons/product-200w.webp"
        imageAlt3="WAAM 3D-печать сопел"
        description1="Внедрение роботизированного комплекса для 3D-наплавки трубопроводной арматуры: производительность участка выросла в 25 раз, брак наплавки устранён"
        description2="Внедрение ORTHODROM для резки и гибки шин с оптимизацией раскроя: использование материала 80 → 98%, расчётная экономия 50–70 млн ₸ в год"
        description3="Автоматизация подготовки моделей для пробивного комплекса Salvagnini: одна модель — за 20 минут вместо рабочего дня, загрузка оборудования выросла в 3,5 раза"
        description4="3D-печать сопел ракетных двигателей из Inconel 718 и 316L: два сопла за 2 дня, огневые испытания пройдены, себестоимость снижена в 8 раз"
      ></Component4cards>
      <div className="founder-sections">
        <div className="founder-section">
          <h2 className="H1_medium">Опыт</h2>
          <div className="founder-block">
            <h3>Arcobo и Arcobo Robotics — Алматы</h3>
            <p className="founder-muted">
              Август 2023 — настоящее время · сооснователь и генеральный
              директор ТОО «Аркобо»; с 2025 — директор ТОО «Аркобо Роботикс»
            </p>
            <p className="text_medium">
              Ведёт проекты автоматизации от определения требований заказчика
              до внедрения. Организует разработку собственных программных и
              аппаратных решений. Arcobo Robotics — официальный
              представитель Kawasaki Robotics в Казахстане.
            </p>
          </div>
          <div className="founder-block">
            <h3>СПбПУ Петра Великого — Санкт-Петербург</h3>
            <p className="founder-muted">
              Ноябрь 2017 — октябрь 2022 · инженер, обязанности заместителя
              руководителя лаборатории лёгких материалов и конструкций
            </p>
            <ul className="founder-list text_medium">
              <li>
                Руководство прикладными проектами по WAAM, сварке трением с
                перемешиванием и свариваемым покрытиям
              </li>
              <li>
                Цифровое производство крупногабаритных алюминиевых элементов
                методом WAAM (2017–2019)
              </li>
              <li>
                Технология автоматической многодуговой сварки под флюсом
                труб большого диаметра из стали X100 (2019–2020)
              </li>
              <li>
                Технологии и оборудование аддитивного производства для
                атомной промышленности; преподавание основ сварки
                (2021–2022)
              </li>
            </ul>
          </div>
          <div className="founder-block">
            <h3>Ранее</h3>
            <p className="text_medium">
              «Нева.Волга.Ладога» — инженер в судостроении (2013–2015):
              контроль сварки корпусных конструкций. RusArc (2015–2017):
              ремонт и подготовка парусных судов, металлообработка и сварка.
            </p>
          </div>
        </div>
        <div className="founder-section">
          <h2 className="H1_medium">Образование</h2>
          <ul className="founder-list text_medium">
            <li>
              СПбПУ Петра Великого — магистр металлургии (2011–2013),
              сварочные материалы; бакалавр металлургии (2007–2011),
              материаловедение и сварочные технологии
            </li>
            <li>
              Санкт-Петербургский государственный технологический институт —
              аспирантура по химической технологии (2013–2017),
              органосиликатные материалы и физико-химические процессы при
              сварке
            </li>
          </ul>
        </div>
        <div className="founder-section">
          <h2 className="H1_medium">Публикации и выступления</h2>
          <ul className="founder-list text_medium">
            <li>
              Соавтор научных статей по WAAM и сварочным процессам в
              Coatings, Metal Science and Heat Treatment, Materials Science
              and Engineering A (2019–2022). Scopus Author ID: 57205488832
            </li>
            <li>
              Автор и соавтор 4 патентов (RU и KZ)
            </li>
            <li>
              Спикер Digital Almaty 2024 и 2025, Kazakhstan Machinery Fair
              2025; модератор сессии по автоматизации EKTU R&D FORUM 2024.
              Выпускник Industrial AI Acceleration 2026 в Astana Hub
            </li>
          </ul>
        </div>
      </div>
      <FooterMain></FooterMain>
    </div>
  )
}

export default LeonidZhabrev
